module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAABNUlEQVRYhc2Y4QqCQBCEv6cMhEAIgkAIAiEQonszX8Cfvo/98AS5buo0vXZgQWhvd5jZ9O4AHNACHfAkP5zv3fpnemCYxSMjmUfQu8ezG4JoMpBpIn07GG0KfxiA+45k7qKnmxJC6aaodyBTi15voxKTcABuG5K5iR5yRJSU1w3IXEXtr6OhJK1+IFOJmskjoaS9rCBzEbUWj4KS+LygxlnUWD0CSupTwtqTWPuL9YCWvPywphRr1lgehZL+GMk9itwlVidBWVDMcgqRk2LxKigrDj6WWrsJlCWplu4CZY2yMguURZOF2WGKkCnLTA21qb+9qRejqU+HqY+rqe2HqQ2aqS2sqU2+qWOQqYOiqaO0Ewl/u2wI74eiEu6A2Ij0MN5cRaXLgHBUWhhl6n24jGQmPOf9X618e8XRzvpIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close_button@2x.png
// module id = llSU
// module chunks = 28